import request from '@/plugins/request'
export const getLangList = (query) => {
    return request({
        url: '/api/sysUser/getLangList',
        method: 'get',
        params: query
    })
}

export const sendEmail = (email) => {
    return request({
        url: '/api/sysUser/sendEmail',
        method: 'post',
        data: { email }
    })
}

export const register = (data) => {
    return request({
        url: '/api/sysUser/register',
        method: 'post',
        data
    })
}

export const getCaptchaImage = () => {
    return request({
        url: '/api/captchaImage',
        method: 'get'
    })
}

export const getOSSToken = (query) => {
    return request({
        url: '/api/upload/ossToken',
        method: 'post',
        params: query
    })
}

export const login = (data) => {
    return request({
        url: '/api/sysUser/login',
        method: 'post',
        data
    })
}

export const getInfo = () => {
    return request({
        url: '/api/sysUser/getInfo',
        method: 'get'
    })
}

export const logout = () => {
    return request({
        url: '/api/logout',
        method: 'post'
    })
}

export const getSignUrl = (url) => {
    return request({
        url: '/api/upload/getSignUrl',
        method: 'get',
        params: { url }
    })
}

export const recoverPassword = (data) => {
    return request({
        url: '/api/sysUser/recoverPassword',
        method: 'post',
        data
    })
}

export const getIp = () => {
    return request({
        url: '/api/sysUser/getIp',
        method: 'get'
    })
}

export const saveMessage = (data) => {
    return request({
        url: '/api/i18nMessage/save',
        method: 'post',
        data
    })
}

export const getCateList = (params) => {
    return request({
        url: '/api/i18nCategory/cateList',
        method: 'get',
        params
    })
}

export const getZhCateList = (params) => {
    return request({
        url: '/api/i18nCategory/zhCateList',
        method: 'get',
        params,
        headers: { 'Accept-Language': 'zh-CN' }
    })
}

export const saveTag = (data) => {
    return request({
        url: '/api/i18nTag/save',
        method: 'post',
        data,
        headers: { 'Accept-Language': 'zh-CN' }
    })
}

export const getTagList = (params) => {
    return request({
        url: '/api/i18nTag/tagList',
        method: 'get',
        params
    })
}

export const updateTag = (data) => {
    return request({
        url: '/api/i18nTag/update',
        method: 'post',
        data,
        headers: { 'Accept-Language': 'zh-CN' }
    })
}

export const saveCreation = (data) => {
    return request({
        url: '/api/i18nCreation/save',
        method: 'post',
        data,
        headers: { 'Accept-Language': 'zh-CN' }
    })
}

export const getCreationList = (params) => {
    return request({
        url: '/api/i18nCreation/creationList',
        method: 'get',
        params
    })
}

export const updateCreation = (data) => {
    return request({
        url: '/api/i18nCreation/update',
        method: 'post',
        data,
        headers: { 'Accept-Language': 'zh-CN' }
    })
}

export const getLikeList = (data) => {
    return request({
        url: '/api/i18nCreation/likeList',
        method: 'get',
        params: data
    })
}

export const getCreationDetail = (id) => {
    return request({
        url: '/api/i18nCreation/creationDetail',
        method: 'get',
        params: { id }
    })
}

export const likeCreation = (creationId) => {
    return request({
        url: `/api/i18nCreation/like/${creationId}`,
        method: 'post'
    })
}

export const onOffCreation = (creationId) => {
    return request({
        url: `/api/i18nCreation/onOff/${creationId}`,
        method: 'post',
        headers: { 'Accept-Language': 'zh-CN' }
    })
}